import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-survey-edit',
  templateUrl: './customer-survey-edit.component.html',
  styleUrls: ['./customer-survey-edit.component.css']
})
export class CustomerSurveyEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
